/**
 * @author Jorge Perales
 * @description  Class Base to focues all the validators types
 * @date 30-04-2025
 * @export
 * @class BaseValidator
 */
export default class BaseValidator {

    /**
     * @author Jorge Perales
     * @description Creates an instance of BaseValidator.
     * @date 30-04-2025
     * @param {*} t
     * @memberof BaseValidator
     */
    constructor(t) {
        this.t = t; // Translation function (i18n)
        this.regexs = {
            text: new RegExp(/^[A-Za-zñÑáéíóúÁÉÍÓÚüÜàèìòùÀÈÌÒÙ\s\d]+$/),
            number: new RegExp(/^\d+$/),
            phoneNumber: new RegExp(/^[-]?[0-9]+[\.]?[0-9]+$/),
            email: new RegExp(/^[^\s@]+@[^\s@]+\.[^\s@]+$/),
            password: new RegExp(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[.@#$%^&*!_-])[A-Za-z\d!@#$%^&*._-]{10,16}$/),
            direction: new RegExp(/^[A-Za-z0-9 áéíóúÁÉÍÓÚÑñ.,;:#-]+$/),
            zipCode: new RegExp(/(^\d{5}$)|(^\d{5}-\d{4}$)/),
            date: new RegExp(/^\d{4}-\d{2}-\d{2}$/), //Format: YYYY-MM-DD 
            domain: new RegExp(/^((?!@)([a-z0-9._-]+\.)+[a-z0-9_-]{1,})$/),
        };
    }

    /**
     * @author Jorge Perales
     * @description Validate just if it´s empty a text input
     * @date 30-04-2025
     * @param {*} value
     * @param {String} tClave
     * @return {*} Base validators (return error message ('this.t(`${tClave}`)') or false if valid)
     * @memberof BaseValidator
     */
    validateText(value, tClave) { return value?.trim() ? false : this.t(`${tClave}`) }

    /**
     * @author Jorge Perales
     * @description Full validation of a text input
     * @date 30-04-2025
     * @param {*} value
     * @param {String} tClave
     * @return {*} Base validators (return error message ('this.t(`${tClave}`)') or false if valid)
     * @memberof BaseValidator
     */
    validateTextStrict(value, tClave) { return value?.trim() && this.regexs.text.test(value.trim()) ? false : this.t(`${tClave}`) }

    /**
     * @author Jorge Perales
     * @description Full validation of a number input
     * @date 30-04-2025
     * @param {*} value
     * @param {String} tClave
     * @return {*} Base validators (return error message ('this.t(`${tClave}`)') or false if valid)
     * @memberof BaseValidator
     */
    validateNumber(value, tClave) {
        const numValue = Number(value);
        if (!isNaN(numValue) && this.regexs.number.test(String(value)) && numValue > 0) return false
        return this.t(`${tClave}`)
    }

    /**
     * @author Jorge Perales
     * @description Full validation of an email input
     * @date 30-04-2025
     * @param {*} value
     * @param {String} tClave
     * @return {*} Base validators (return error message ('this.t(`${tClave}`)') or false if valid)
     * @memberof BaseValidator
     */
    validateEmail(value, tClave) { return this.regexs.email.test(value) ? "" : this.t(`${tClave}`) }

    /**
     * @author Jorge Perales
     * @description Full validation of a date input
     * @date 30-04-2025
     * @param {*} value
     * @param {String} tClave
     * @return {*} Base validators (return error message ('this.t(`${tClave}`)') or false if valid)
     * @memberof BaseValidator
     */
    validateDate(value, tClave) { return value ? false : this.t(`${tClave}`) }

    /**
     * @author Jorge Perales
     * @description Full validation of an option in a select inptut with a default value
     * @date 30-04-2025
     * @param {*} value
     * @param {String} tClave
     * @return {*} Base validators (return error message ('this.t(`${tClave}`)') or false if valid)
     * @memberof BaseValidator
     */
    validationOptionDefault(value, tClave, defaultValue) { return value?.trim() || value?.trim() !== defaultValue ? false : this.t(`${tClave}`) }

    /**
     * @author Jorge Perales
     * @description Return the error message ('this.t(`${tClave}`)') whitout validation
     * @date 30-04-2025
     * @param {*} value
     * @param {String} tClave
     * @return {*}
     * @memberof BaseValidator
     */
    default(tClave) { return this.t(`${tClave}`) }
}